__turbopack_context__.v({
  "container": "DealsBanner-module__Uc3H-G__container",
  "header": "DealsBanner-module__Uc3H-G__header",
});
